const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowProductGroup', ['ProductGroupService', require('./productgroup-directive')]);
wowApp.directive('wowProductGroupProducts', ['ProductGroupService', 'SettingsService', '$timeout', 'ShopPageStateService', '$stateParams', 'FiltersService', 'SearchService', require('./productgroup-products-directive')]);
wowApp.directive('bwsProductGroupCarousel', ['SettingsService', require('./productgroup-carousel-directive')]);
wowApp.service('ProductGroupCarouselService', [require('./product-group-carousel-service')]);

wowApp.constant('carouselConfig', {
    method: {},
    lazyLoad: 'ondemand',
    infinite: false,
    speed: 300,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    accessibility: true,
    touchThreshold: 8,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                dots: true,
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 992,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
});



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroups/index.js
 **/